import Link from "next/link";
import Image from "next/future/image";
import blogData from "../../blogs.json";

const allCaseStudies = blogData
  .filter(item => item?.meta?.category === "case-study")
  .map(item => ({
    title: item.meta.title || "",
    slug: item.meta.slug || "",
    img: item.meta.img || null,
    industry_descriptor: item.meta.industry_descriptor || null,
    outcome_metric: item.meta.outcome_metric || null,
    refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
    date: item.meta.date || "",
  }));

export default function SuccessStoryEmbed({
  referTag,
  maxItems = 3,
  heading = "Work we've shipped for clients like you",
}) {
  let stories = referTag
    ? allCaseStudies.filter(s => s.refer.includes(referTag))
    : [];

  if (stories.length === 0) {
    stories = [...allCaseStudies].sort((a, b) => (b.date > a.date ? 1 : -1));
  }

  const visible = stories.slice(0, maxItems);
  if (!visible.length) return null;

  return (
    <section className="py-12 px-6 md:px-[60px] bg-gray-50 text-left">
      <div className="max-w-6xl">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left">
          {heading}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {visible.map(story => (
            <Link key={story.slug} href={`/blog/${story.slug}`}>
              <a className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col">
                {story.img && (
                  <div className="relative w-full h-44 bg-gray-100">
                    <Image
                      src={story.img}
                      alt={story.title}
                      fill
                      className="object-cover"
                      sizes="(max-width: 768px) 100vw, 400px"
                      placeholder="blur"
                      blurDataURL="/blogImages/hero/placeholder.webp"
                    />
                  </div>
                )}
                <div className="p-5 flex flex-col flex-1">
                  {story.industry_descriptor && (
                    <p className="text-blue-500 text-xs uppercase tracking-wide font-medium mb-2">
                      {story.industry_descriptor}
                    </p>
                  )}
                  <h3 className="text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1">
                    {story.title}
                  </h3>
                  {story.outcome_metric && (
                    <p className="text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100">
                      {story.outcome_metric}
                    </p>
                  )}
                </div>
              </a>
            </Link>
          ))}
        </div>

        <div>
          <Link href="/success-stories">
            <a className="inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm">
              See all success stories →
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
}
